module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/introduction01_sp-14db7684ceb16b678983692960ab35cf.png";